/* KP Größen-Gruppen v3 (07.09.2026) – gliedert die Stempelgrößen in "Rund" und "Eckig".
   Zwei kleine Zwischenüberschriften; bei den runden Maßen wird das Wort "rund/round/rond"
   aus der ANZEIGE genommen (25mm rund -> 25mm), weil die Gruppenüberschrift es schon sagt.
   WICHTIG: Nur der sichtbare Text wird gekürzt. Der Optionswert selbst bleibt "25mm rund" –
   so steht in Bestellung, Lieferschein und Merchant Center weiterhin die Form dabei.
   Greift NUR, wenn eine Optionsgruppe sauber in zwei Blöcken liegt: erst alle runden,
   dann alle eckigen Maße. Sonst passiert nichts (z. B. HS003 Hochzeitsstempel). */
(function () {
  var TEXT = {
    de: { r: 'Rund', e: 'Eckig' },
    en: { r: 'Round', e: 'Square & rectangular' },
    nl: { r: 'Rond', e: 'Vierkant & rechthoekig' }
  };
  var RUND = /(^|[^a-z])(rund|round|rond)([^a-z]|$)/i;
  var RUND_ENDE = /\s*(rund|round|rond)\s*$/i;
  var ECKIG = /^\s*\d+\s*[x×]\s*\d+/i;
  var CLS = 'kp-sizehead';

  function texte() {
    var l = (document.documentElement.getAttribute('lang') || 'de').slice(0, 2).toLowerCase();
    return TEXT[l] || TEXT.de;
  }

  function css() {
    if (document.getElementById('kp-sizehead-css')) return;
    var st = document.createElement('style');
    st.id = 'kp-sizehead-css';
    st.textContent =
      '.' + CLS + '{display:block;width:100%;margin:1.2rem 0 .6rem;font-size:1.2rem;' +
      'letter-spacing:.06rem;text-transform:uppercase;opacity:.62;line-height:1;}' +
      '.' + CLS + '--erste{margin-top:.2rem;}';
    (document.head || document.documentElement).appendChild(st);
  }

  /* Sichtbaren Text einer Pille setzen, ohne den Zusatz für Screenreader anzutasten */
  function setzeText(label, text) {
    for (var i = 0; i < label.childNodes.length; i++) {
      var n = label.childNodes[i];
      if (n.nodeType === 3 && n.nodeValue.trim()) {
        if (n.nodeValue.trim() !== text) n.nodeValue = text;
        return;
      }
    }
  }

  function kopf(text, erste) {
    var h = document.createElement('span');
    h.className = CLS + (erste ? ' ' + CLS + '--erste' : '');
    h.textContent = text;
    return h;
  }

  function apply(root) {
    var T = texte();
    var groups = (root || document).querySelectorAll('.product-form__input--pill');
    for (var g = 0; g < groups.length; g++) {
      var fs = groups[g];
      var inputs = fs.querySelectorAll('input[type="radio"]');
      if (inputs.length < 2) continue;

      /* Form jedes Werts: r = rund, e = eckiges Maß, x = etwas anderes */
      var muster = '';
      for (var i = 0; i < inputs.length; i++) {
        var v = inputs[i].value || '';
        muster += RUND.test(v) ? 'r' : (ECKIG.test(v) ? 'e' : 'x');
      }

      var vorhanden = fs.querySelectorAll('.' + CLS);
      /* Nur bei sauberem Blockwechsel: erst alle runden, dann alle eckigen */
      if (!/^r+e+$/.test(muster)) {
        for (var k = 0; k < vorhanden.length; k++) vorhanden[k].remove();
        continue;
      }

      var ersteRund = inputs[0];
      var ersteEckig = inputs[muster.indexOf('e')];

      /* Stehen beide Überschriften schon richtig? Dann nur noch die Texte prüfen. */
      var stimmt = vorhanden.length === 2 &&
        vorhanden[0].nextElementSibling === ersteRund &&
        vorhanden[1].nextElementSibling === ersteEckig &&
        vorhanden[0].textContent === T.r &&
        vorhanden[1].textContent === T.e;

      if (!stimmt) {
        for (var m = 0; m < vorhanden.length; m++) vorhanden[m].remove();
        ersteRund.parentNode.insertBefore(kopf(T.r, true), ersteRund);
        ersteEckig.parentNode.insertBefore(kopf(T.e, false), ersteEckig);
      }

      /* "rund" aus der Anzeige der runden Maße nehmen – der Wert selbst bleibt unberührt */
      for (var j = 0; j < inputs.length; j++) {
        if (muster.charAt(j) !== 'r') continue;
        var lab = inputs[j].nextElementSibling;
        if (!lab || lab.tagName !== 'LABEL') continue;
        var kurz = (inputs[j].value || '').replace(RUND_ENDE, '').trim();
        if (kurz) setzeText(lab, kurz);
      }
    }
  }

  css();
  window.kpGroessenGruppe = { apply: apply, version: 3 };

  if (typeof document !== 'undefined' && document.addEventListener) {
    var scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      setTimeout(function () { scheduled = false; apply(); }, 0);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { apply(); });
    else apply();
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
